<template>
	<!-- 客户管理 -->
	<div class="saleCustomerManagement">
		<div class="public_Spacing customerManagementPC">
			<!-- <div class="rankingListMain" id="main">

			</div> -->
			<el-row class="row-main" :gutter="24">
				<el-col :span="18">
					<el-card class="box-card">
						<div class="gcbodyblock" style="">
							<div class="que-date-mk">
								<div style="padding-right:60px;">
									<span>销售排行榜</span>
								</div>
								<div class="sel-kq">
									<div class="selected-right">
										<label class="public_lbSty">客户：</label>
										<el-select @change="changeDatazb1()" :disabled="khSelTs"
											class="public_optionSty dropDown_Define" v-model="customerMo1"
											placeholder="请选择" filterable>
											<el-option v-for="item in customerOptions" :key="item.ORMTB410ID"
												:label="item.ORMTB410CA00" :value="item.ORMTB410ID">
											</el-option>
										</el-select>
									</div>
									<div class="public_oparetionBlock_Menu">
										<label class="">企业：</label>
										<el-select class="public_optionSty dropDown_Define" :disabled='cjSelTs'
											@change="erpChange1" v-model="enterpriseTwo1" placeholder="请选择">
											<el-option v-for="item in enterpriseTwoOptionList" :key="item.SETTB99ID"
												:label="item.SETTB99CA00" :value="item.SETTB99ID">
											</el-option>
										</el-select>
									</div>
								</div>
								<div class="public_operatArea-zdy">
									<span class="pulic_operatArea_now pulic_cursor"
										:class="dateNowDayActive?'public_dateActive':''" @click="getNowDay">当日</span>
									<span class="public_operatArea_yesterday pulic_cursor"
										:class="dateYesterdayActive?'public_dateActive':''"
										@click="getYesterday">昨天</span>
									<span class="pulic_operatArea_now pulic_cursor"
										:class="dateNowMonthActive?'public_dateActive':''" @click="sameMonth">当月</span>
									<span class="public_operatArea_yesterday pulic_cursor"
										:class="dateLastMonthActive?'public_dateActive':''" @click="lastMonth">上月</span>
									<div class="public_operatArea_timePicker pulic_cursor">
										<el-date-picker v-model="date" value-format="yyyy-MM-dd" type="daterange"
											range-separator="至" :picker-options="startDateDisabled"
											@change="datePickerChange" start-placeholder="开始日" end-placeholder="结束日"
											class="pulic_cursor">
										</el-date-picker>
									</div>
								</div>
								<div style="padding-left: 15px;" @click="shuaxinDataFun()">
									<button class="public_saleWater_shuaxin pulic_cursor"><i data-v-318db380=""
											class="iconfont icon-shuaxin1"></i>刷新</button>
								</div>
							</div>


							<div class="box">
								<div class="ranktext">
									<div class="text-bd" v-for="(item, index) in chartData" :key="index">
										<div v-if="index =='0'" style="color: #FE2D46;">
											<span>NO.{{ index + 1 }}</span>
											<span style="padding-left: 10px;">{{item.ORMTB410CA00}}</span>
										</div>
										<div v-if="index =='1'" style="color: #F60;">
											<span>NO.{{ index + 1 }}</span>
											<span style="padding-left: 10px;">{{item.ORMTB410CA00}}</span>
										</div>
										<div v-if="index =='2'" style="color: #FAA90E;">
											<span>NO.{{ index + 1 }}</span>
											<span style="padding-left: 10px;">{{item.ORMTB410CA00}}</span>
										</div>
										<div v-if="index >='3'">
											<span>NO.{{ index + 1 }}</span>
											<span style="padding-left: 10px;">{{item.ORMTB410CA00}}</span>
										</div>

									</div>
								</div>
								<div style="width: 83%">
									<div @click="cliFunData(item)" v-for="(item, index) in chartData" :key="index">
										<div id="barChart" class="barChart" style="width: 100%;"></div>
									</div>
								</div>
							</div>

						</div>
					</el-card>
				</el-col>
				<el-col :span="6">
					<el-card class="box-card">
						<div class="gcbodyblock">
							<div class="selected-right">
								<label class="public_lbSty">客户：</label>
								<el-select @change="changeDatazb()" class="public_optionSty dropDown_Define"
									v-model="customerMo" placeholder="请选择" filterable>
									<el-option v-for="item in customerOptions" :key="item.ORMTB410ID"
										:label="item.ORMTB410CA00" :value="item.ORMTB410ID">
									</el-option>
								</el-select>
							</div>
							<div class="ratio-main">
								<div class="cz-left">
									<div>
										<span>充值占比</span>
									</div>
									<div class="">
										<div style="height:225px;" id="rechargeRatio" class="ranktext">

										</div>
									</div>
								</div>
								<div class="cl-right">
									<div>
										<span>车辆占比</span>
									</div>
									<div class="">
										<div style="height:185px;" id="vehicleProportion" class="ranktext">

										</div>
									</div>
								</div>

							</div>
						</div>
					</el-card>
				</el-col>
			</el-row>
			<el-row class="row-car-wl-main" :gutter="24">
				<el-col :span="24">
					<el-card class="box-card">

						<div class="wlsj" style="">
							<div class="wlcxvi">
								<div>
									<span>厂家销量排行榜</span>
								</div>
								<div class="public_operatArea-zdy">
									<span class="pulic_operatArea_now pulic_cursor"
										:class="dateNowDayActive1?'public_dateActive1':''" @click="getNowDay1">当日</span>
									<span class="public_operatArea_yesterday pulic_cursor"
										:class="dateYesterdayActive1?'public_dateActive1':''"
										@click="getYesterday1">昨天</span>
									<span class="pulic_operatArea_now pulic_cursor"
										:class="dateNowMonthActive1?'public_dateActive1':''"
										@click="sameMonth1">当月</span>
									<span class="public_operatArea_yesterday pulic_cursor"
										:class="dateLastMonthActive1?'public_dateActive1':''"
										@click="lastMonth1">上月</span>
									<div class="public_operatArea_timePicker pulic_cursor">
										<el-date-picker v-model="date1" value-format="yyyy-MM-dd" type="daterange"
											range-separator="至" :picker-options="startDateDisabled"
											@change="datePickerChange1" start-placeholder="开始日" end-placeholder="结束日"
											class="pulic_cursor">
										</el-date-picker>
									</div>
								</div>
								<div class="public_oparetionBlock_Menu">
									<label class="">企业：</label>
									<el-select class="public_optionSty dropDown_Define" @change="erpChange"
										v-model="enterpriseTwo" placeholder="请选择">
										<el-option v-for="item in enterpriseTwoOptionList" :key="item.SETTB99ID"
											:label="item.SETTB99CA00" :value="item.SETTB99ID">
										</el-option>
									</el-select>
								</div>
							</div>
							<div class="wlChart" style="">
								<div id="wlChart" style="width: 100%;height:100%;"></div>
							</div>
						</div>
					</el-card>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
	import {
		Decimal
	} from 'decimal.js';
	export default {
		data() {
			return {
				customerManagementList: '',
				customerManagementValue: '',
				customerManagement: false,
				customerManagementAdd: false,
				customerManagementAddName: '',
				customerManagemenUPObj: '',
				customerManagementUpdate: false,
				cusQueryName: '',
				cusQueryiphone: '',
				options: [],
				cusStatus: '',
				cusStatusList: [],
				tableData: [],
				flag: '',
				page: 1,
				pagesize: 10,
				currentPage: 1,
				count: 0,
				currentPage1: 1,
				detailsPageLimit: 10,
				detailsCount: 1,
				RechargetypeValue: '',
				RechargetypeOptions: [],
				CZRecordsDetails: [],
				CZRecordsPage: 1,
				CZRecordsPageLimit: 10,
				CZRecordsCount: 0,
				tableDataDetails: [],
				offerDetailsTab: [],
				ORMTB411ID: '',
				CustomerfillingDig: false,

				tabActive: "1",
				scheduleData: [],
				noticesData: [],
				scrollHeight2: 0,
				animate: false,
				timer1: null,
				chartData: [], //销售排行榜
				rechargeRatio: [], //充值占比
				vehicleProportion: [], //车辆占比
				userobj: this.$store.state.uobj,
				customerMo: '', //客户--查询	
				customerMo1: '', //客户--查询	
				khSelTs: false,
				cjSelTs: false,
				customerOptions: [{
					ORMTB410ID: '',
					ORMTB410CA00: '全部',
				}],
				enterpriseTwoOptionList: [{
					SETTB109CA00: '全部',
					SETTB109ID: '',
				}], //二级企业下拉框
				historyInfo: '',
				// 时间限制
				// 限制开始日期不能超过当前日期
				startDateDisabled: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					}
				},
				date: [], //日期
				dateNowDayActive: false,
				dateYesterdayActive: false,
				dateNowMonthActive: false,
				dateLastMonthActive: false,

				date1: [], //日期
				dateNowDayActive1: false,
				dateYesterdayActive1: false,
				dateNowMonthActive1: false,
				dateLastMonthActive1: false,

				twolevelUserLogin: true,
				timeIndex: 0, //判断第几次切换当月时间
				sameMonthTime: '', //目前月份
				currentMonthTime: '', //目前月份--上月+1
				enterpriseTwo: '', //二级企业
				enterpriseTwo1: '', //二级企业
				CZmoney: '',
				Czmaxlength: 10, //充值限额
				HCmoney: '',
				HCremark: '',
				HCamountCapitalText: '',
				amountCapitalText: '',
				cusInsertShow: false,
				cusInsertObj: {
					ORMTB400ID: '',
					ORMTB410CA00: '',
					ORMTB410CA01: '',
					ORMTB410CA02: '',
					ORMTB410CA06: ''
				},
				cusUpdateShow: false,
				cusUpdateObj: {
					ORMTB400ID: '',
					ORMTB410CA00: '',
					ORMTB410CA01: '',
					ORMTB410CA02: '',
					ORMTB410CA06: ''
				},
				saleWaterDetails: false,
				rechargeTypeDig: false,
				rechargeTypeName: '',
				rechargeTypeUpOBJ: {
					SETTB206CA01: ''
				},
				rechargeTypeModifyDig: false,
				czRechargetypeShow: false,
				HCshow: false,
				HCObj: '',
				preferentialRecord: false,
				offerDetails: false,
				DetailsWater: false,
				deductionRecord: false,
				deductionRecordObj: '',
				deductionRecordtable: [],
				deductionRecordPage: 1,
				deductionRecordLimit: 10,
				deductionRecordCount: 0,
				preferentialType: 0,
				solelist: [],
			};
		},
		created() {
			// 赋值，缓存销毁
			// this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl))
			// sessionStorage.removeItem(this.currentUrl)
			// if (this.historyInfo != null && this.historyInfo != '') {
			// 	this.init()
			// }

			// else {

			// }
		},
		mounted() {
			// if (this.historyInfo == null && this.$route.query.mark == null) {
			// 	this.getNowDay();
			// 	this.getNowDay1();
			// 	this.startTime = this.date[0];
			// 	this.endTime = this.date[1];
			// 	this.startTime1 = this.date1[0];
			// 	this.endTime1 = this.date1[1];
			// 	this.dateNowDayActive = true
			// 	this.dateNowDayActive1 = true
			// }
			this.getNowDay();
			this.getNowDay1();
			this.startTime = this.date[0];
			this.endTime = this.date[1];
			this.startTime1 = this.date1[0];
			this.endTime1 = this.date1[1];
			this.dateNowDayActive = true
			this.dateNowDayActive1 = true
			// this.querycusList()
			this.queryVehicleProportionList()
			this.queryRechargeRatioList()
			// this.querySelectWLTopTenList()
			this.enterprise0ptions()
			this.optionLists()

		},
		// 存储数据
		beforeDestroy() {
			// var obj = {
			// 	startTime: [this.date[0], this.date[1]], //开始时间

			// 	dateNowDayActive: this.dateNowDayActive,
			// 	dateYesterdayActive: this.dateYesterdayActive,
			// 	dateNowMonthActive: this.dateNowMonthActive,
			// 	dateLastMonthActive: this.dateLastMonthActive,

			// 	startTime1: [this.date1[0], this.date1[1]], //开始时间

			// 	dateNowDayActive1: this.dateNowDayActive1,
			// 	dateYesterdayActive1: this.dateYesterdayActive1,
			// 	dateNowMonthActive1: this.dateNowMonthActive1,
			// 	dateLastMonthActive1: this.dateLastMonthActive1,


			// }
			// sessionStorage.setItem(this.currentUrl, JSON.stringify(obj))
		},
		methods: {
			//初始化数据
			init() {
				this.date = this.historyInfo.startTime
				this.dateNowDayActive = this.historyInfo.dateNowDayActive
				this.dateYesterdayActive = this.historyInfo.dateYesterdayActive
				this.dateNowMonthActive = this.historyInfo.dateNowMonthActive
				this.dateLastMonthActive = this.historyInfo.dateLastMonthActive

				this.date1 = this.historyInfo.startTime1
				this.dateNowDayActive1 = this.historyInfo.dateNowDayActive1
				this.dateYesterdayActive1 = this.historyInfo.dateYesterdayActive1
				this.dateNowMonthActive1 = this.historyInfo.dateNowMonthActive1
				this.dateLastMonthActive1 = this.historyInfo.dateLastMonthActive1

			},

			//获取当前时间
			getNowDay() {
				var date = new Date().getTime();
				var nowDay = this.$baseAPI.dateFtt("yyyy-MM-dd", new Date(date));
				this.date = [nowDay, nowDay];
				this.dateNowDayActive = true
				this.dateYesterdayActive = false
				this.dateNowMonthActive = false
				this.dateLastMonthActive = false
				this.querycusList()
			},
			//获取当前时间
			getNowDay1() {
				var date = new Date().getTime();
				var nowDay = this.$baseAPI.dateFtt("yyyy-MM-dd", new Date(date));
				this.date1 = [nowDay, nowDay];
				this.dateNowDayActive1 = true
				this.dateYesterdayActive1 = false
				this.dateNowMonthActive1 = false
				this.dateLastMonthActive1 = false
				this.querySelectWLTopTenList()
			},
			datePickerChange(e) {
				this.dateNowDayActive = false
				this.dateYesterdayActive = false
				this.dateNowMonthActive = false
				this.dateLastMonthActive = false
				this.querycusList()
			},
			datePickerChange1(e) {
				this.dateNowDayActive1 = false
				this.dateYesterdayActive1 = false
				this.dateNowMonthActive1 = false
				this.dateLastMonthActive1 = false
				this.querySelectWLTopTenList()
			},
			//获取昨天时间
			getYesterday() {
				var hms = new Date().getTime() - 86400000;
				var nowDay = this.$baseAPI.dateFtt("yyyy-MM-dd", new Date(hms));
				this.date = [nowDay, nowDay];
				this.dateNowDayActive = false
				this.dateYesterdayActive = true
				this.dateNowMonthActive = false
				this.dateLastMonthActive = false
				this.querycusList()
			},

			//获取昨天时间
			getYesterday1() {
				var hms = new Date().getTime() - 86400000;
				var nowDay = this.$baseAPI.dateFtt("yyyy-MM-dd", new Date(hms));
				this.date1 = [nowDay, nowDay];
				this.dateNowDayActive1 = false
				this.dateYesterdayActive1 = true
				this.dateNowMonthActive1 = false
				this.dateLastMonthActive1 = false
				this.querySelectWLTopTenList()
			},

			//获取当月时间
			sameMonth() {
				var date = new Date();
				var hms = date.setDate(1);
				var firstDay = this.$baseAPI.dateFtt("yyyy-MM-dd", new Date(hms));
				var nextdate = new Date().getTime();
				var nextDay = this.$baseAPI.dateFtt("yyyy-MM-dd", new Date(nextdate));
				this.date = [firstDay, nextDay];
				this.startTime = this.date[0];
				this.endTime = this.date[1];
				this.dateNowDayActive = false
				this.dateYesterdayActive = false
				this.dateNowMonthActive = true
				this.dateLastMonthActive = false
				this.querycusList()
			},
			//获取当月时间
			sameMonth1() {
				var date = new Date();
				var hms = date.setDate(1);
				var firstDay = this.$baseAPI.dateFtt("yyyy-MM-dd", new Date(hms));
				var nextdate = new Date().getTime();
				var nextDay = this.$baseAPI.dateFtt("yyyy-MM-dd", new Date(nextdate));
				this.date1 = [firstDay, nextDay];
				this.startTime1 = this.date1[0];
				this.endTime1 = this.date1[1];
				this.dateNowDayActive1 = false
				this.dateYesterdayActive1 = false
				this.dateNowMonthActive1 = true
				this.dateLastMonthActive1 = false
				this.querySelectWLTopTenList()
			},

			//获取上月时间
			lastMonth() {
				var nowdays = new Date();
				var year = nowdays.getFullYear();
				var month = nowdays.getMonth();
				if (month == 0) {
					month = 12;
					year = year - 1;
				}
				if (month < 10) {
					month = "0" + month;
				}
				var firstDayOfPreMonth = year + "-" + month + "-" + "01";
				var lastDay = new Date(year, month, 0);
				let lastDayOfPreMonth = year + "-" + month + "-" + lastDay.getDate();
				this.date = [firstDayOfPreMonth, lastDayOfPreMonth];
				this.dateNowDayActive = false
				this.dateYesterdayActive = false
				this.dateNowMonthActive = false
				this.dateLastMonthActive = true
				this.querycusList()
			},
			//获取上月时间
			lastMonth1() {
				var nowdays = new Date();
				var year = nowdays.getFullYear();
				var month = nowdays.getMonth();
				if (month == 0) {
					month = 12;
					year = year - 1;
				}
				if (month < 10) {
					month = "0" + month;
				}
				var firstDayOfPreMonth = year + "-" + month + "-" + "01";
				var lastDay = new Date(year, month, 0);
				let lastDayOfPreMonth = year + "-" + month + "-" + lastDay.getDate();
				this.date1 = [firstDayOfPreMonth, lastDayOfPreMonth];
				this.dateNowDayActive1 = false
				this.dateYesterdayActive1 = false
				this.dateNowMonthActive1 = false
				this.dateLastMonthActive1 = true
				this.querySelectWLTopTenList()
			},


			// 客户--查询
			enterprise0ptions() {
				var postData = {
					ORMTB400ID: this.userobj.ormtb400.ORMTB400ID //一级企业id
				}
				var List = [{
					ORMTB410ID: '',
					ORMTB410CA00: '全部',
				}];
				var url = "/orm/ormtb410/selectOrmtb410s";
				this.axios.post(url, postData).then(res => {
					if (res.data.code == 200) {
						// 客户
						this.customerOptions = [...List, ...res.data.data];
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				})
			},
			erpChange() {
				this.querySelectWLTopTenList()
				// if (this.enterpriseTwo != '') {
				// 	this.querySelectWLTopTenList()
				// } else {
				// 	// this.materielOptions = [{
				// 	// 	SETTB109CA00: '全部',
				// 	// 	SETTB109ID: '',
				// 	// }]
				// 	this.querySelectWLTopTenList()
				// }
			},
			erpChange1() {
				if (!this.enterpriseTwo1) {
					this.khSelTs = false
				} else {
					this.khSelTs = true
				}
				this.querycusList()

				// if (this.enterpriseTwo != '') {
				// 	this.querySelectWLTopTenList()
				// } else {
				// 	// this.materielOptions = [{
				// 	// 	SETTB109CA00: '全部',
				// 	// 	SETTB109ID: '',
				// 	// }]
				// 	this.querySelectWLTopTenList()
				// }
			},

			cliFunData(row) { //点击查询客销量
				console.log(row)
				if (row.ORMTB410ID) {
					this.customerMo1 = row.ORMTB410ID
					this.cjSelTs = true;
					this.khSelTs = false;
					this.enterpriseTwo1 = '';
					this.querycusList()
				} else {
					this.enterpriseTwo1 = row.ORMTB440CA04
					this.cjSelTs = false;
					this.khSelTs = true;
					this.customerMo1 = '';
					this.querycusList()
				}

			},
			shuaxinDataFun() { //点击从新刷新销售数据排行榜
				this.customerMo1 = '';
				this.enterpriseTwo1 = ''
				this.cjSelTs = false;
				this.khSelTs = false;
				this.querycusList()
			},

			// 获取下拉框信息--二级企业
			optionLists() {
				var postData = {
					SETTB100CA02: '', //用户类型
					ORMTB400ID: this.userobj.ormtb400.ORMTB400ID //一级企业id
				}
				var List = [{
					SETTB99ID: '',
					SETTB99CA00: '全部',
				}];
				var url = "/set/settb100/selectSettb100ByCa02";
				this.axios.post(url, postData).then(res => {
					if (res.data.code == 200) {
						var data = res.data.data
						// 二级企业
						this.enterpriseTwoOptionList = [...List, ...data];
						if (this.enterpriseTwoOptionList.length == 2) {
							this.enterpriseTwo = this.enterpriseTwoOptionList[1].SETTB99ID
							this.materielMoPost()
						}
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					// this.pageList()
				}).catch(() => {
					// this.pageList()
					loading.close();
				})
			},

			changeDatazb() {
				// console.log(this.customerMo)
				this.queryRechargeRatioList()
				this.queryVehicleProportionList()
			},
			changeDatazb1() {
				// console.log(this.customerMo1)
				if (!this.customerMo1) {
					this.cjSelTs = false
				} else {
					this.cjSelTs = true
				}

				this.querycusList()
			},

			querycusList() { //销售排行榜数据
				var url = "/orm/ormtb420/selectTopTen"
				var postData = {
					startTime: this.date[0], //开始时间
					endTime: this.date[1], //结束时间
					khid: this.customerMo1, //客户id
					qyid: this.enterpriseTwo1 //企业id
				}
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.chartData = res.data.data;
						setTimeout(() => {
							this.barCharts1()
						}, 100)

						// this.count = res.data.count;
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},

			querySelectWLTopTenList() { //厂家排行榜数据
				// this.tableData = []
				// this.flag = dataFlag
				// this.count =0
				var url = "/orm/ormtb420/selectWLTopTen"
				// if(!this.customerMo){
				// 	this.userobj.ormtb400.ORMTB410ID = ''
				// }
				var postData = {
					startTime: this.date1[0], //开始时间
					endTime: this.date1[1], //结束时间
					SETTB99ID: this.enterpriseTwo,
					// ORMTB410CA00: this.cusQueryName, //客户名称
					// ORMTB410CA02: this.cusQueryiphone, //客户名称
					// flag: dataFlag, //查询所有客户全部展示
					// page: this.page,
					// limit: this.pagesize
				}
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						// this.rechargeRatio = res.data.data;
						// console.log(this.rechargeRatio)
						this.wlChartVive(res.data.data.names, res.data.data.values, res.data.data.counts, res.data
							.data.weis)
						// this.count = res.data.count;
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},

			queryRechargeRatioList() { //充值占比数据
				// this.tableData = []
				// this.flag = dataFlag
				// this.count =0
				var url = "/orm/ormtb420/selectPie"
				// if(!this.customerMo){
				// 	this.userobj.ormtb400.ORMTB410ID = ''
				// }
				var postData = {
					ORMTB410ID: this.customerMo,
					// ORMTB410CA00: this.cusQueryName, //客户名称
					// ORMTB410CA02: this.cusQueryiphone, //客户名称
					// flag: dataFlag, //查询所有客户全部展示
					// page: this.page,
					// limit: this.pagesize
				}
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						// this.rechargeRatio = res.data.data;
						// console.log(this.rechargeRatio)
						this.rankingList(res.data.data)
						// this.count = res.data.count;
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			queryVehicleProportionList() { //车辆占比数据
				// this.tableData = []
				// this.flag = dataFlag
				// this.count =0
				var url = "/orm/ormtb420/selectCarPie"
				// if(!this.customerMo){
				// 	this.userobj.ormtb400.ORMTB410ID = ''
				// }

				var postData = {
					// ORMTB410ID: this.userobj.ormtb400.ORMTB410ID,
					ORMTB410ID: this.customerMo,

					// ORMTB410CA00: this.cusQueryName, //客户名称
					// ORMTB410CA02: this.cusQueryiphone, //客户名称
					// flag: dataFlag, //查询所有客户全部展示
					// page: this.page,
					// limit: this.pagesize
				}
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						// this.vehicleProportion = res.data.data;

						this.vehicleProportionListView(res.data.data)
						// this.count = res.data.count;
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			formatCurrency(number) {
			  return new Intl.NumberFormat('zh-CN', {
			    style: 'currency',
			    currency: 'CNY',
			    minimumFractionDigits: 2
			  }).format(number);
			},
			wlChartVive(names, values, counts, weis) { //厂家销量排行榜
				let myChart = this.$echarts.init(document.getElementById('wlChart'))
				var option;

				option = {
					// tooltip: {
					// 	trigger: 'axis',
					// 	axisPointer: {
					// 		type: 'shadow'
					// 	}
					// },
					grid: {
						left: '1%',
						right: '1%',
						bottom: '1%',
						top: '5%',
						containLabel: true
					},
					xAxis: [{
						type: 'category',
						data: names,
						axisTick: {
							alignWithLabel: true
						},
						axisLabel: {
							interval: 0

						}
					}],
					dataZoom: [{
							type: 'slider', //滑动条
							show: true, //开启
							xAxisIndex: [0],
							// left: '93%', //滑动条位置
							bottom: -50, // 滑动条距离底部的距离
							start: 0, //初始化时，滑动条宽度开始标度
							end: 30, //初始化时，滑动条宽度结束标度
							textStyle: {
								color: "#fff"
							},
							backgroundColor: "#acb7c3", // 设置背景颜色
							handleStyle: {
								color: "#2a82e4", // 设置左右两边的可滑动收缩竖线颜色
							}
						},

						{
							type: 'inside', //内置滑动，随鼠标滚轮展示
							xAxisIndex: [0],
							start: 0, //初始化时，滑动条宽度开始标度
							end: 5 //初始化时，滑动条宽度结束标度
						}
					],
					yAxis: [{
						type: 'value'
					}],
					series: [{
							name: '元',
							type: 'bar',
							barWidth: '40%',
							stack: 'total',
							label: {
								show: true,
								// fontSize: 16,
								fontWeight: 'bold',
								// color: '#990000',
								position: 'top',
								// return `{a|}${values[params.dataIndex]}元\u0020\u0020{b|}${counts[params.dataIndex]}车\n\n${weis[params.dataIndex]}吨`;
								formatter: function(params) {
									// let str = ''
									// str = '{c|}' + ' 上升\n' + values[params.dataIndex] + '元'
									// return `${values[params.dataIndex]}元\u0020\u0020${counts[params.dataIndex]}车\n\n${weis[params.dataIndex]}吨`;

									var a = values[params.dataIndex] / weis[params.dataIndex]
									
									var je = new Intl.NumberFormat().format(values[params.dataIndex]);
									return '{a|' + je + ' 元\n' + '}' + '{d|' + a.toFixed(2) + ' 均价\n' + '}'+ '{b|' + counts[
											params.dataIndex] + ' 车\n' + '}' + '{c|' + weis[params.dataIndex] +
										' 吨' + '}'




									// return {a| + values[params.dataIndex] + }{b|+ counts[params.dataIndex] + };
								},

								rich: {
									a: {
										color: '#FF0000',
										fontSize: 14,
									},
									b: {
										color: '#0000FF',
										fontSize: 14,
										
									},
									c: {
										color: '#990000',
										fontSize: 14,
										
										
									},
									d: {
										color: '#00CC99',
										fontSize: 14,
										height:25
										
									}
								}


							},

							emphasis: {
								focus: 'series'
							},
							data: values
						},
						// {
						// 	name: '车次',
						// 	type: 'line',
						// 	lineStyle: {
						// 		color: "rgba(1, 1, 1, 0)"
						// 	},
						// 	symbol: 'circle',
						// 	symbolSize: 1,
						// 	label: {
						// 		show: true,
						// 		color: '#FFCC00',
						// 		fontSize: 12,
						// 		fontWeight: 'bold',
						// 		position: 'inside',
						// 		formatter: function(val) {
						// 			return `${val.data}车`;
						// 		},
						// 	},
						// 	showBackground: false,
						// 	data: counts
						// },
						// {
						// 	name: '吨数',
						// 	type: 'line',
						// 	lineStyle: {
						// 		color: "rgba(1, 1, 1, 0)"
						// 	},
						// 	symbol: 'circle',
						// 	symbolSize: 1,
						// 	label: {
						// 		show: true,
						// 		color: '#3366FF',
						// 		fontSize: 12,
						// 		fontWeight: 'bold',
						// 		position: 'inside',
						// 		formatter: function(val) {
						// 			return `${val.data}吨`;
						// 		},
						// 	},
						// 	showBackground: false,
						// 	data: weis
						// }
					]
				};

				option && myChart.setOption(option);
			},


			barCharts1() { //销售排行榜
				var a = document.getElementsByClassName('barChart')
				for (var i = 0; i < a.length; i++) {
					var barCharts = this.$echarts.init(a[i]);
					var option = {
						backgroundColor: "",
						grid: {
							left: "13px", // 距离dom间距
							right: "30%",
							top: "10%",
							bottom: "1px",
						},
						xAxis: [{
							show: false,
							type: "value",
							axisPointer: {
								type: "shadow",
							},
							// 横坐标 分割线等取消显示
							axisTick: {
								show: false,
							},
							axisLine: {
								show: false,
							},
							splitLine: {
								show: false,
							},
							axisLabel: {
								show: false,
							},
						}, ],
						yAxis: [{
								//左侧文字
								type: "category",
								inverse: true,
								axisLabel: {
									verticalAlign: "top",
									align: "top",
									padding: [0, 10, 10, 8],
									textStyle: {
										fontSize: 22,
										color: (params) => {
											return '#54dc54';
										},

										fontFamily: "SourceHanSansCN-Regular",
									},
									// textStyle: {
									// 	fontSize: 14,
									// 	color: "#54dc54",
									// 	fontFamily: "SourceHanSansCN-Regular",
									// },
									formatter(value, index) {
										index += 1;
									},
									rich: {
										rank: {
											width: 36,
											height: 10,
											color: "#54dc54",
											align: "center",
											marginRight: 10,
										},
									},
								},
								// 纵坐标数据
								data: this.chartData[i].ORMTB420CA02,
								yAxisIndex: 0,
								// 横坐标 分割线等取消显示
								axisTick: {
									show: false,
								},
								axisLine: {
									show: false,
								},
							},
							{
								//右侧文字
								type: "category",
								inverse: true,
								axisLine: {
									show: false,
								},
								axisTick: {
									show: false,
								},
								axisLabel: {
									show: true,
									inside: false,
									verticalAlign: "right",
									// 位置 上右下左
									padding: [0, 0, 0, 5],
									lineHeight: "0",
									// 控制竖着字体颜色
									textStyle: {
										fontSize: 22,
										color: (params) => {
											return "#54dc54";
										},

										fontFamily: "SourceHanSansCN-Regular",
									},
									formatter: function(value) {
										return "{x|" + value + "} {y|" + "}";
									},
									rich: {
										x: {
											fontWeight: "bold",
											fontSize: 17,
										},
										y: {
											fontSize: 10,
											lineHeight: 0,
											alignItems: "bottom",
										},
									},
								},

								data: [this.chartData[i].ORMTB420CA02], //[1000]//myData,
							},
							{
								//左侧柱状图的Y轴
								// gridIndex: 0,//y轴所在的 grid 的索引
								splitLine: "none",
								axisTick: "none",
								axisLine: "none",
								data: [this.chartData[i].ORMTB420CA02],
							},
						],
						series: [

							// {
							// 	//顶层间隔
							// 	show: true,
							// 	type: "pictorialBar",
							// 	symbol: "fixed",
							// 	symbolSize: [0, 10],
							// 	symbolMargin: 10,
							// 	symbolRepeat: "repeat",
							// 	barWidth: 6, // 统计条宽度
							// 	itemStyle: {
							// 		normal: {
							// 			color: "#ec9e00",
							// 		},
							// 	},
							// 	z: 2,
							// 	data: [this.ydata], //[80]//ydata,
							// },
							{
								//中间层
								show: true,
								type: "bar",
								xAxisIndex: 0, //使用的 x 轴的 index，在单个图表实例中存在多个 x 轴的时候有用。
								yAxisIndex: 0, //使用的 y 轴的 index，在单个图表实例中存在多个 y轴的时候有用。
								barGap: "-100%",
								barWidth: "10px", // 统计条宽度
								max: 1,
								labelLine: {
									show: false,
								},
								z: 1,
								itemStyle: {
									normal: {
										color: (params) => {
											return '#409EFF';
										},
									},
								},
								data: [this.chartData[i].ydata], //[80]//ydata,
							},
							{
								//底层背景
								name: "外框",
								show: true,
								type: "bar",
								xAxisIndex: 0, //使用的 x 轴的 index，在单个图表实例中存在多个 x 轴的时候有用。
								yAxisIndex: 2, //使用的 y 轴的 index，在单个图表实例中存在多个 y 轴的时候有用。
								symbolMargin: 0,
								barGap: "-100%",
								barWidth: 16, // 统计条宽度
								itemStyle: {
									normal: {
										color: "#F3F3F3",
									},
								},
								z: 0,
								data: [100], //[100]//grayBar,
							},
						],
					};
					barCharts.setOption(option);
					barCharts.resize({
						width: "auto",
						height: "20",
					});
				}
			},



			rankingList(data) { //充值金额占比
				let myChart = this.$echarts.init(document.getElementById('rechargeRatio'))


				// var top = myChart * 1;
				var option = {
					// color: ['red', 'coral'],
					tooltip: {
						trigger: 'item'
					},
					toolbox: {
						// name: '充值金额',
						show: true,
						feature: {
							mark: {
								show: true
							},
							dataView: {
								show: true,
								readOnly: false
							},
							// restore: { show: true },
							// saveAsImage: { show: true }
						}
					},
					series: [{
						name: '充值金额',
						type: 'pie',
						radius: ["30%", "50%"],
						center: ['50%', '50%'],
						avoidLabelOverlap: true, //是否启用防止标签重叠策略
						minAngle: 5,
						minShowLabelAngle: 10,
						padding: 0,
						// roseType:'area',
						// width: 400,
						// itemStyle: {
						// 	borderColor: '#fff',
						// 	borderWidth: 1
						// },
						itemStyle: {
							borderRadius: 5
						},
						label: {
							align: 'right',
							minMargin: 5,
							normal: {
								formatter(v) {
									// console.log(v)
									// Math.round(v.value)
									let text = v.name + `\n${v.value}`
									return text
									// console.log(text)
									// if (text.length <= 8) {
									// 	return text;
									// } else if (text.length > 8 && text.length <= 16) {
									// 	return text = `${text.slice(0,8)}\n${text.slice(8)}`
									// } else if (text.length > 16 && text.length <= 24) {
									// 	return text =
									// 		`${text.slice(0,8)}\n${text.slice(8,16)}\n${text.slice(16)}`
									// } else if (text.length > 24 && text.length <= 30) {
									// 	return text =
									// 		`${text.slice(0,8)}\n${text.slice(8,16)}\n${text.slice(16,24)}\n${text.slice(24)}`
									// } else if (text.length > 30) {
									// 	return text =
									// 		`${text.slice(0,8)}\n${text.slice(8,16)}\n${text.slice(16,24)}\n${text.slice(24,30)}\n${text.slice(30)}`
									// }
								},
								position: 'outer',
								alignTo: 'labelLine',

								show: true,

								// position: "outer",

								/* textStyle: {
									fontSize: 12
								}, */
								// rich: {
								// 	name: {
								// 		fontSize: myFontSize,
								// 		//lineHeight: myFontSize,
								// 	}
								// }
							}

							// alignTo: 'edge',
							// formatter: '{name|{b}}\n{time|{c} 元}',
							// minMargin: 10,
							// edgeDistance: 10,
							// lineHeight: 15,
							// rich: {
							// 	time: {
							// 		fontSize: 10,
							// 		color: '#999'
							// 	}
							// }
						},
						// labelLine: {
						// 	show: true,
						// 	length: 5,
						// 	length2: 5,
						// },

						// labelLayout: function(params) {
						// 	const isLeft = params.labelRect.x < myChart.getWidth() / 2;
						// 	const points = params.labelLinePoints;
						// 	// Update the end point.
						// 	points[2][0] = isLeft ?
						// 		params.labelRect.x :
						// 		params.labelRect.x + params.labelRect.width;
						// 	return {
						// 		labelLinePoints: points
						// 	};
						// },

						emphasis: {
							show: true,
							textStyle: {
								fontSize: "10",
								fontWeight: "bold"
							}

						},
						labelLine: {
							show: true,
							length: 15,
							length2: 0,
							maxSurfaceAngle: 80
						},
						data: data,
					}]
				};

				option && myChart.setOption(option);

			},

			vehicleProportionListView(data) { //车辆占比
				let myChart = this.$echarts.init(document.getElementById('vehicleProportion'))
				// console.log(this.vehicleProportion)
				var option = {
					// title: {
					// 	text: 'Referer of a Website',
					// 	subtext: 'Fake Data',
					// 	left: 'center'
					// },
					color: ['green', 'cyan'],
					tooltip: {
						trigger: 'item'
					},
					legend: {
						orient: 'vertical',
						left: 'left'
					},
					series: [{
						name: '车辆',
						type: 'pie',
						radius: '50%',
						data: data,
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}]
				};
				option && myChart.setOption(option);

			}




		}
	};
</script>

<style scoped>
	.saleCustomerManagement {
		overflow: hidden;
	}

	.homePC-content {
		overflow: hidden;
	}

	.customerManagementPC {
		background-color: #F3F3F3;
		width: 100%;
		height: 100%;
		padding-top: 10px;
		overflow: hidden;
	}

	.row-main {
		/* height: 300px; */
	}

	.row-car-wl-main {
		margin-top: 10px;
	}

	.rankingListMain {
		height: 300px;
		width: 100%;
	}

	.box {
		display: flex;
		justify-content: center;
		height: 400px;
		overflow: auto;
	}

	.gcbodyblock {
		height: 450px;
	}

	.barChart {
		height: 40px;
	}

	.ratio-main {
		width: 100%;
		/* height: 20px; */
		/* display: flex; */
		/* justify-content: space-between; */
	}

	.cz-left {
		width: 100%;
	}

	.cl-right {
		width: 100%;
	}

	.selected-right {
		text-align: center;
	}

	.text-bd {
		width: 100%;
		height: 40px;
		/* line-height: 30px; */
		margin: 0 auto;
		/* padding-top:6px; */
	}

	.ranktext {
		/* padding-top: 10px; */
		height: 100%;
		/* float: left; */
	}

	.wlsj {
		width: 100%;
		height: 100%;
	}

	.wlChart {
		height: 835px;
	}

	.wlcxvi {
		display: flex;
		justify-content: space-between;
	}

	.public_lbSty {
		width: 10px;
	}


	.pulic_operatArea_now:hover,
	.public_operatArea_yesterday:hover {
		background-color: #ccc;
	}

	.que-date-mk {
		display: flex;
		padding-bottom: 10px;
		/* justify-content: space-between; */
		align-items: center;
	}

	.public_operatArea-zdy {
		display: flex;
		flex-flow: wrap;
		box-sizing: border-box;
		align-items: center;

	}

	.public_dateActive1 {
		color: rgb(93, 178, 255) !important;
	}

	.sel-kq {
		display: flex;
	}
</style>